<script setup>
import { Head, useForm, Link } from '@inertiajs/inertia-vue3';
import { ref } from "vue";
import { __ } from '@/app';
import axios from "axios";
import LayoutNew from '@/Layouts/LayoutNew.vue';
import BreezeInput from '@/Components/Input.vue';
import SubmitButton from '@/Components/SubmitButton.vue';

const props = defineProps({
    flash: Object,
    auth: Object
});

const form = useForm({
    message: ''
});

const successMessage = ref(null);
const errorMessage = ref(null);

const submit = async () => {
    try {
        const res = await axios.post(route("contact.send"), form);
        successMessage.value = res.data.message;
        errorMessage.value = null;
        form.message = '';
    } catch (error) {
        errorMessage.value = error.response.data.error;
        successMessage.value = null;
    }
};

</script>
<template>
    <LayoutNew>
        <Head title="Contact" />
        <div style="max-width: 600px;">
            <h2 class="text-center">{{ __('Skontaktuj się z nami') }}</h2>
            <p class="text-center">{{ __('Masz pytania lub sugestie? Chcesz pomóc nam ulepszyć platformę? Napisz do nas!') }}</p>
            
            <div v-if="successMessage" class="alert alert-success mb-4">{{ successMessage }}</div>
            <div v-if="errorMessage" class="alert alert-danger mb-4">{{ errorMessage }}</div>
            
            <template v-if="auth?.user">
                <form @submit.prevent="submit">
                    <div class="mb-3">
                        <label for="message" class="form-label">{{ __('Wiadomość') }}</label>
                        <textarea class="form-control" id="message" rows="6" v-model="form.message" v-bind:placeholder="__('Twoja wiadomość...')" required></textarea>
                    </div>
                    <SubmitButton v-bind:text="__('Wyślij wiadomość')" />
                </form>
            </template>
            <template v-else>
                <div class="text-center">
                    <p class="alert alert-info">{{ __('Aby wysłać wiadomość, musisz być zalogowany.') }}</p>
                    <Link :href="route('login')" class="btn btn-primary">
                        {{ __('Zaloguj się') }}
                    </Link>
                </div>
            </template>
        </div>        
    </LayoutNew>
</template>